import { ChartTypeEnum } from "../../../models/chart";
import AdminChartsHeader from "./components/admin-charts-header";
import AdminChartsList from "./components/admin-charts-list";
import useAdminCharts, { AdminChartsState } from "./hooks/use-admin-charts";

type AdminGeneralChartsProps = {
  chartType: ChartTypeEnum;
};

export default function AdminGeneralCharts(props: AdminGeneralChartsProps) {
  const adminChartsState: AdminChartsState = useAdminCharts(props.chartType);

  return (
    <div className="flex flex-col flex-grow w-full">
      <AdminChartsHeader state={adminChartsState} />
      <AdminChartsList state={adminChartsState} />
    </div>
  );
}
